import { getHealthScoreSummary } from "@/services/core-api-adapter";
import { useQuery } from "@tanstack/react-query";

export const healthScoreSummaryQueryKey = ["healthScoreSummary"] as const;

export default function useGetHealthScoreSummary() {
  const { data, isPending, isLoading, isError, refetch } = useQuery({
    queryKey: healthScoreSummaryQueryKey,
    queryFn: async ({ signal }) => {
      const res = await getHealthScoreSummary({ signal });
      return res;
    },
  });

  const refetchSummary = refetch;

  return {
    healthScoreSummary: data ?? null,
    isHealthScoreSummaryLoading: isPending || isLoading,
    healthScoreSummaryFetchError: isError,
    refetchSummary,
  };
}
